import { useState } from "react"

export const Membership = () => {
    const [mbrshpModal, setMbrshpModalModal] = useState(false)
    const [mbrshpDetails, setMbrshpDetail] = useState({ id: '', data: {}, mid: '', inclusions: [], validity: 0 })
    const [mbrshpList, setMbrshpList] = useState([])
    const [mbrshpLoader, setMbrshpLoader] = useState({ view: false, init: true })
    const [mbrshpFilter, setMbrshpFilter] = useState({ membership_id: 'All', from: '', to: '', search: '' })
    const [mbrshpRegistrants, setMbrshpRegistrants] = useState([])
    const [mbrshpHasMore, setMbrshpHasMore] = useState(true)
    const [mbrshpPage, setMbrshpPage] = useState(1)
    return {
        mbrshpModal: { data: mbrshpModal, set: setMbrshpModalModal },
		mbrshpDetails: { data: mbrshpDetails, set: setMbrshpDetail },
		mbrshpList: { data: mbrshpList, set: setMbrshpList },
		mbrshpLoader: { data: mbrshpLoader, set: setMbrshpLoader },
		mbrshpFilter: { data: mbrshpFilter, set: setMbrshpFilter },
		mbrshpRegistrants: { data: mbrshpRegistrants, set: setMbrshpRegistrants },
        mbrshpHasMore: { data: mbrshpHasMore, set: setMbrshpHasMore },
		mbrshpPage: { data: mbrshpPage, set: setMbrshpPage },
    }
}